import { Link } from 'react-router-dom'
import usePageTitle from '@/hooks/usePageTitle'

function NotFound() {
    usePageTitle('404')
    return (
        <div className="flex flex-col items-center justify-center min-h-[50vh] gap-4">
            <h1 className="text-4xl font-bold">404</h1>
            <p className="text-gray-500">Page introuvable</p>
            <Link to="/" className="text-black underline">
                Retour à l'accueil
            </Link>
        </div>
    )
}

export default NotFound
